<template>
  <div class="weeklist-wrap">
    <van-row
      v-if="weeks && weeks.length > 0"
      class="search"
      gutter="15"
      type="flex"
      align="center"
    >
      <van-col>
        <div>选择榜单</div>
      </van-col>
      <van-col>
        <div class="search-item" @click="cityPicker = true">
          <span>{{ cityName }}</span>
          <van-icon name="arrow-down" />
        </div>
      </van-col>
      <van-col>
        <div class="search-item" @click="typePicker = true">
          <span v-if="type == 1">参赛人数</span>
          <span v-if="type == 2">参赛人次</span>
          <span v-if="type == 3">综合排名</span>
          <van-icon name="arrow-down" />
        </div>
      </van-col>
      <van-col>
        <div class="search-item" @click="weekPicker = true">
          <span>{{ weekText }}</span>
          <van-icon name="arrow-down" />
        </div>
      </van-col>
    </van-row>
    <div class="tips">温馨提示：榜单排名每日0点更新一次</div>
    <empty v-if="loading === false && list.length === 0" :tag="true" />
    <template v-else>
      <div class="custom-table">
        <div v-if="type == 3" class="custom-thead">
          <van-row style="text-align: center">
            <van-col span="12">综合排名</van-col>
            <van-col span="12">区县榜</van-col>
          </van-row>
        </div>
        <div v-if="type == 3" class="custom-tbody stripe">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了~"
            @load="getData"
          >
            <van-row
              v-for="(item, index) in list"
              :key="index"
              style="text-align: center"
            >
              <van-col span="12">{{ index + 1 }}</van-col>
              <van-col span="12">{{ item.county_name }}</van-col>
            </van-row>
          </van-list>
        </div>
        <div v-else class="custom-tbody">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了~"
            @load="getData"
          >
            <van-row type="flex" v-for="(item, index) in list" :key="index">
              <van-col class="row-label" span="12"
                >{{ item.ranking }}.{{ item.county_name }}</van-col
              >
              <van-col span="12" v-if="type == 1"
                >{{ item.peoples_repeat }}人</van-col
              >
              <van-col span="12" v-if="type == 2">{{ item.times }}人次</van-col>
              <van-col span="24" v-if="type == 1"
                ><van-progress
                  :percentage="
                    Math.round(
                      (Number(item.peoples_repeat) / Number(sum)) * 100
                    )
                  "
                  stroke-width="8"
                  :show-pivot="false"
              /></van-col>
              <van-col span="24" v-if="type == 2"
                ><van-progress
                  :percentage="
                    Math.round((Number(item.times) / Number(sum)) * 100)
                  "
                  stroke-width="8"
                  :show-pivot="false"
              /></van-col>
            </van-row>
          </van-list>
        </div>
      </div>
    </template>
    <van-popup
      v-model="typePicker"
      round
      position="bottom"
      get-container="body"
    >
      <van-picker
        title=""
        show-toolbar
        :columns="[
          { code: 1, text: '参赛人数' },
          { code: 2, text: '参赛人次' },
          { code: 3, text: '综合排名' },
        ]"
        @cancel="typePicker = false"
        @confirm="typeConfirm"
      />
    </van-popup>
    <van-popup
      v-model="weekPicker"
      round
      position="bottom"
      get-container="body"
    >
      <van-picker
        title=""
        show-toolbar
        :columns="weeks"
        @cancel="weekPicker = false"
        @confirm="weekConfirm"
      />
    </van-popup>
    <van-popup
      v-model="cityPicker"
      round
      position="bottom"
      get-container="body"
    >
      <van-picker
        title=""
        show-toolbar
        value-key="name"
        :columns="citys"
        @cancel="cityPicker = false"
        @confirm="cityConfirm"
        :default-index="defIndex"
      />
    </van-popup>
  </div>
</template>
<script>
import Empty from "./Empty";
export default {
  components: {
    Empty,
  },
  props: {
    weeks: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      // 列表
      list: [],
      loading: false,
      currentPage: 1,
      finished: false,
      week: 0,
      weekText: "全部时段",
      type: 1,
      typePicker: false,
      weekPicker: false,
      sum: 0,
      citys: [],
      cityName: "太原市",
      cityCode: "140100000000",
      cityPicker: false,
      defIndex: 0,
    };
  },
  methods: {
    // 获取排行榜数据
    async getData() {
      try {
        this.loading = true;
        const res = await this.$axios.post(`/Statis/statsRegionWeek`, {
          page: this.currentPage,
          size: 200,
          type: this.type,
          week: this.week,
          code: this.cityCode,
          level: 2,
        });
        if (res.data && res.data.list.length > 0) {
          // res.data.list.forEach((element) => {
          //   this.list.push(element);
          // });
          // this.currentPage++;
          this.list = res.data.list;
        }
        this.sum = 0;
        if (this.list && this.list.length > 0) {
          let persScore = 0;
          let ranking = 0;
          if (Number(this.type) === 1) {
            this.list.forEach((item, index) => {
              this.sum += Number(item.peoples_repeat);
              if (Number(item.peoples_repeat) != persScore) {
                persScore = Number(item.peoples_repeat);
                ranking = index + 1;
              }
              item.ranking = ranking;
            });
          } else if (Number(this.type === 2)) {
            this.list.forEach((item, index) => {
              this.sum += Number(item.times);
              if (Number(item.times) != persScore) {
                persScore = Number(item.times);
                ranking = index + 1;
              }
              item.ranking = ranking;
            });
          } else {
            // this.list.forEach((item) => {
            //   this.sum += Number(item.merge);
            //   if (Number(item.merge) == persScore) {
            //     item.ranking = ranking;
            //     isRepeat = true;
            //   } else {
            //     if (isRepeat) {
            //       ranking = ranking + 2;
            //       isRepeat = false;
            //     } else {
            //       ranking++;
            //     }
            //     persScore = Number(item.merge);
            //     item.ranking = ranking;
            //   }
            // });
            this.list.sort((a, b) => {
              if (Number(a.ranking) == Number(b.ranking)) {
                if (Number(a.peoples_repeat) == Number(b.peoples_repeat)) {
                  return Number(b.times) - Number(a.times);
                } else {
                  return Number(b.peoples_repeat) - Number(a.peoples_repeat);
                }
              } else {
                return Number(a.ranking) - Number(b.ranking);
              }
            });
          }
        }
        this.loading = false;
        // if (this.list.length >= Number(res.data.total)) {
        this.finished = true;
        // }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || `获取数据失败`,
          duration: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
    async loadArea(code = "140000000000") {
      try {
        const res = await this.$axios.post(`/Region/getRegionList`, {
          level: 2,
          code: code,
        });
        this.citys = res.data ?? [];
        this.defIndex = this.citys.findIndex((v) => v.code == this.cityCode);
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || "获取地区信息失败！",
          duration: 2000,
        });
      }
    },
    typeConfirm(value) {
      this.finished = false;
      this.loading = false;
      this.list = [];
      this.currentPage = 1;
      this.type = value.code;
      this.getData();
      this.typePicker = false;
    },
    weekConfirm(value) {
      this.finished = false;
      this.loading = false;
      this.list = [];
      this.currentPage = 1;
      this.weekText = value.text;
      this.week = value.code;
      this.getData();
      this.weekPicker = false;
    },
    cityConfirm(value) {
      this.finished = false;
      this.loading = false;
      this.list = [];
      this.currentPage = 1;
      this.cityName = value.name;
      this.cityCode = value.code;
      this.getData();
      this.cityPicker = false;
    },
  },
  created() {
    this.getData();
    this.loadArea();
  },
};
</script>
<style lang="scss" scoped>
.weeklist-wrap {
  .search {
    margin: 15px 20px;
    font-size: 12px;
    color: #333;
    .search-item {
      padding: 6px 4px;
      color: #999;
      cursor: pointer;
      border: 1px solid #c8c8c8;
      border-radius: 4px 4px 4px 4px;
      .van-icon-arrow-down {
        color: #3b60fc;
      }
      & > span {
        margin-right: 4px;
      }
    }
  }
  .tips {
    width: 100%;
    padding: 4px 16px;
    font-size: 12px;
    line-height: 25px;
    color: #00a3ff;
    text-align: left;
    background: rgba(0, 178, 255, 0.16);
  }

  .custom-table {
    .custom-thead {
      .van-row {
        padding: 0 10px;
      }
    }
    .custom-tbody {
      height: calc(100vh - 31px - 51px - 64px);
      overflow: auto;
      .van-row {
        padding: 0 10px;
        font-size: 14px;
        line-height: 16px;
        text-align: right;
        .row-label {
          text-align: left;
        }
      }
    }
  }
}
</style>
